import { Form } from 'antd';
import { useState } from 'react';
import type {
    ProdutoBodyVariacao,
    ProdutoBodyVariacaoGrade,
} from '@/features/produto/types/ProdutoBody';
import { TableDefault } from '@/components/antd/TableDefault';
import { showTotal } from '@/std/pagination/showTotal';
import { getColumns } from './columns';

export function TableGrade({
    value,
    onChange,
}: {
    value?: ProdutoBodyVariacao | null;
    onChange: (value: ProdutoBodyVariacao) => void;
}) {
    const grade = value?.grade || [];

    const [editingKey, setEditingKey] = useState<string | null>(null);
    const [tableForm] = Form.useForm<ProdutoBodyVariacaoGrade>();

    const data = grade.filter((g) => g.excluir !== 'S');

    const edit = (grade: ProdutoBodyVariacaoGrade): void => {
        setEditingKey(grade.pro_descricao);
        tableForm.setFieldsValue(grade);
    };

    const save = (): void => {
        const editedRow = tableForm.getFieldsValue();

        const newGrade: ProdutoBodyVariacaoGrade[] = grade.map((item) => {
            if (item.pro_descricao === editingKey) {
                const grade = { ...item, ...editedRow, alterar: true };

                if (grade.produto_foto?.[0]?.foto_base64) {
                    grade.foto = undefined;
                }

                return grade;
            }

            return item;
        });

        onChange({ ...value, grade: newGrade });
        cancel();
    };

    const cancel = (): void => {
        setEditingKey(null);
        tableForm.resetFields();
    };

    const remove = (descricao: string): void => {
        const newGrade: ProdutoBodyVariacaoGrade[] = [];

        for (const g of grade) {
            // Produto não foi cadastrado
            if (g.pro_idpk === null) {
                if (g.pro_descricao === descricao) {
                    // se é o que está editando não adiciona na nova lista
                } else {
                    // se não adiciona na nova lista
                    newGrade.push(g);
                }

                continue;
            }

            // Tem produto cadastrado

            if (g.excluir === 'S' || g.pro_descricao === descricao) {
                // se é o que está editando ou já está marcado para exclusão, marca para exclusão
                newGrade.push({ ...g, excluir: 'S' });
            } else {
                // se não, mantém como está
                newGrade.push(g);
            }
        }

        onChange({ ...value, grade: newGrade });
    };

    const selectFoto = (fileName: string, base64: string): void => {
        tableForm.setFieldsValue({
            produto_foto: [
                {
                    foto_base64: base64,
                    foto_nome: fileName,
                    prf_foto_principal: 1,
                },
            ],
        });
    };

    const columns = getColumns({
        cancel,
        edit,
        editingKey,
        remove,
        save,
        selectFoto,
    });

    return (
        <Form component={false} form={tableForm}>
            <TableDefault
                columns={columns}
                dataSource={data}
                pagination={{ showTotal }}
                rowKey='pro_descricao'
            />
        </Form>
    );
}
